// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5257ae1c","453":"eaea9c73","455":"f0b307c4"}[chunkId] + ".chunk.js";
};